<template>
  <div class="pa-4" style="position: relative">
    <h2 class="subheading green--text">Help for Finance</h2>
    <HelpFinance class="larawan" />
    <img
      src="@/assets/Consulting-rafiki.svg"
      class="bg"
      position="right"
      height="450"
      width="auto"
    />
  </div>
</template>

<script>
import HelpFinance from "@/components/Utils/Help-Finance.vue";
export default {
  components: {
    HelpFinance,
  },
  data: () => ({}),
};
</script>

<style scoped>
.bg {
  border-style: none;
  position: absolute;
  right: 10px;
  top: 160px;
  opacity: 0.5;
  z-index: 1;
}
.larawan {
  z-index: 2;
  opacity: 1;
}
</style>